<template>
  <v-dialog
      width="500"
      v-model="dialog"
      persistent>
      <v-card>
        <v-card-title
          primary-title
        >
          {{ $t('headline') }}
        </v-card-title>
        <v-card-text>
          {{ $t('cookie_text') }}
        </v-card-text>
         <v-card-actions class="text-center justify-center mb-5">
          <v-btn
            color="default"
            depressed
            @click="dismissCookieConsent"
            class="mr-3"
          >
            {{ $t('button_deny') }}
          </v-btn>

          <v-btn
            color="primary"
            depressed
            @click="acceptCookieConsent"
            data-cy="acceptCookieConsent"
          >
            {{ $t('button_accept') }}
          </v-btn>
        </v-card-actions>
        <v-card-text class="text-center mt-3">
          <v-btn
            text
            small
            color="grey"
            class="mr-3"
            href="https://www.conclimate.de/datenschutz"
            target="_blank"
          >
            {{ $t('privacy') }}
          </v-btn>
          <v-btn
            text
            small
            color="grey"
            href="https://www.conclimate.de/impressum"
            target="_blank"
          >
            {{ $t('imprint') }}
          </v-btn>
        </v-card-text>

      </v-card>

</v-dialog>
</template>

<i18n>
{
  "en": {
      "headline": "Cookie Settings",
      "cookie_text": "We use cookies on our website. Some of them are essential while others help us to improve this website and your experience.",
      "button_accept": "Accept",
      "button_deny": "Deny",
      "imprint": "Imprint",
      "privacy": "Privacy Policy"
  },
  "de": {
      "headline": "Cookie Einstellungen",
      "cookie_text": "Wir nutzen Cookies auf unserer Website. Einige von ihnen sind essenziell, während andere uns helfen, diese Website und Ihre Erfahrung zu verbessern.",
      "button_accept": "Akzeptieren",
      "button_deny": "Ablehnen",
      "imprint": "Impressum",
      "privacy": "Datenschutz"
  }
}
</i18n>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'CookieConsentLayer',
  methods: {
    dismissCookieConsent() {
      this.SET_COOKIE_CONSENT_LAYER_DECLINED();
      this.SET_COOKIE_CONSENT_PROCESSED();
    },
    acceptCookieConsent() {
      // bootstrap();
      this.SET_COOKIE_CONSENT_LAYER_ACCEPTED();
      this.SET_COOKIE_CONSENT_PROCESSED();
    },
    ...mapMutations('cookieConsent', [
      'SET_COOKIE_CONSENT_PROCESSED',
      'SET_COOKIE_CONSENT_LAYER_DECLINED',
      'SET_COOKIE_CONSENT_LAYER_ACCEPTED',
    ]),
  },
  computed: {
    ...mapGetters('cookieConsent', [
      'cookieConsentProcessed',
    ]),
    dialog() {
      if (!this.cookieConsentProcessed) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
